import * as React from 'react';

export interface EditableTitleProps {
  dataHook?: string;
  initialValue?: string;
  defaultValue?: string;
  onSubmit?: (value: string) => void;
  maxLength?: number;
  autoFocus?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
}

export default class EditableTitle extends React.Component<EditableTitleProps> {}
